<template>
	<div id="app">
		<pdf :url="pdfUrl" />
	</div>
</template>

<script>
import pdf from '@/components/pdf.vue';

export default {
	components: { pdf },

	data () {
		return {
			pdfUrl: null,
			loading: false,
		}
	},

	computed: {
		visitId() {
			return this.$route?.params?.visitId || null
		}
	},

	methods: {
		revokePdfUrl() {
			if (this.pdfUrl) {
				URL.revokeObjectURL(this.pdfUrl)
				this.pdfUrl = null
			}
		},

		print() {
			if (!this.visitId) {
				this.revokePdfUrl()
				return
			}

			this.loading = true
			this.$store.dispatch('visits/printInvoice', {
				visitId: this.visitId,
				posDevice: false,
			}).then((response) => {
				const blob = response?.data instanceof Blob
					? response.data
					: new Blob([response?.data], { type: 'application/pdf' })

				this.revokePdfUrl()
				this.pdfUrl = URL.createObjectURL(blob)
			}).catch(() => {
				this.revokePdfUrl()
				this.$eventBus.$emit('show-snackbar', this.$T('invoice-preview.failed-load'), 'error')
			}).finally(() => {
				this.loading = false
			})
		}
	},

	watch: {
		visitId: {
			immediate: true,
			handler() {
				this.print()
			}
		}
	},

	beforeDestroy() {
		this.revokePdfUrl()
	}
}
</script>